import { get } from './apiUtils';

const defaultUrl = '/cpsrChapters/';

export default {
  getCpsrChaptersList: () => get(defaultUrl),
};
